import {
  backgroundInverse,
  chemicalSupplierGradient,
  gradient,
  textInverse,
  textSecondary,
} from './colors';

export interface CustomCiamUiTheme {
  backgroundColor: string;
  footerTextColor: string;
  footerLinkColor: string;
  headerBackgroundColor: string;
  buttonColorPrimary: string;
}

export const dsoTheme = {
  backgroundColor: gradient,
  footerTextColor: textInverse,
  footerLinkColor: 'inherit',
  headerBackgroundColor: backgroundInverse,
};

export const resellerTheme = {
  backgroundColor: 'white',
  footerTextColor: textSecondary,
  footerLinkColor: '#473A6D !important',
  headerBackgroundColor: backgroundInverse,
};

export const iteroTheme = {
  backgroundColor: 'rgba(133, 134, 137, 1)',
  footerTextColor: textInverse,
  footerLinkColor: 'inherit',
  headerBackgroundColor: backgroundInverse,
};

export const iteroScannerTheme = {
  backgroundColor: 'transparent',
  footerTextColor: textInverse,
  footerLinkColor: 'inherit',
  headerBackgroundColor: backgroundInverse,
};

export const consumerTheme = {
  backgroundColor: 'white',
  footerTextColor: textSecondary,
  footerLinkColor: 'inherit',
  headerBackgroundColor: backgroundInverse,
};

export const axiTheme = {
  backgroundColor: 'white',
  footerTextColor: textSecondary,
  footerLinkColor: '#009ACE !important',
  headerBackgroundColor: backgroundInverse,
};

export const chemicalComplianceTheme = {
  backgroundColor: chemicalSupplierGradient,
  footerTextColor: textInverse,
  footerLinkColor: 'inherit',
  headerBackgroundColor: backgroundInverse,
};
